import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "../constants/constant";
import { Service } from "../services/service";

const service = new Service();

export const initialState = {
  allEnvironment: [],
  loading: false,
  currentTrendId: null,
  isEnvironmentAdded: false,
  isConnect: false,
};

export const getAllEnvironment = createAsyncThunk(
  "get-all-environment",
  async (obj) => {
    const url = `${BASE_URL}/api/Environment/GetAllEnvironments`;
    const params = obj;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testGetApi(url, params, user_token);
    const data = response.data;
    return data;
  }
);

export const createEnvironment = createAsyncThunk(
  "create-environment",
  async ({ data }) => {
    let url = `/api/Environment/AddEnvironment`;
    data = JSON.stringify(data);
    const user_token = localStorage.getItem("bb_access_token");
    let response = await service.newPostApi(url, data, user_token);
    return response;
  }
);

const environmentSlice = createSlice({
  name: "environment",
  initialState,
  reducers: {
    updateCurrentTrend(state, action) {
      state.currentTrendId = action.payload;
    },
    updateIsConnect: (state, { payload }) => {
      state.isConnect = payload;
    },
  },
  extraReducers: {
    [getAllEnvironment.pending]: (state) => {
      state.loading = true;
    },
    [getAllEnvironment.fulfilled]: (state, { payload }) => {
      state.allEnvironment = payload;
      state.loading = false;
    },
    [getAllEnvironment.rejected]: (state) => {
      state.loading = false;
    },
    [createEnvironment.pending]: (state, action) => {
      state.loading = true;
    },
    [createEnvironment.fulfilled]: (state, { payload }) => {
      state.status = payload.response.status;
      state.loading = false;
      state.isEnvironmentAdded = true;
    },
    [createEnvironment.rejected]: (state, { payload }) => {
      state.loading = false;
    },
  },
});

export const { updateCurrentTrend, updateIsConnect } = environmentSlice.actions;
export default environmentSlice.reducer;
